/**
 * 候选人池接口。
 * 契约：GET /candidates?eventCode=（过滤规则 event_code = X OR event_code IS NULL）、
 *       POST /candidates、DELETE /candidates/:id → 204。
 */
import { api, queryString } from './client.js';
import type { CandidateCreateDto, CandidateDto, CandidateInput, CandidatesDto } from './types.js';

export const candidatesApi = {
  list: (eventCode?: string): Promise<CandidatesDto> =>
    api.get<CandidatesDto>(`/candidates${queryString({ eventCode })}`),

  /**
   * 新增候选人 → 201 {candidate, via}。
   * via 标注实际解析路径（T75/T76）：'rule' 表示智能解析不可用、已用规则兜底。
   */
  create: (input: CandidateInput): Promise<CandidateCreateDto> => api.post<CandidateCreateDto>('/candidates', input),

  remove: (candidateId: string): Promise<void> =>
    api.delete<void>(`/candidates/${encodeURIComponent(candidateId)}`),
};

export type { CandidateDto, CandidateInput };